import { NAME } from './constants';

export const RESET = `${NAME}/RESET`;
export const CHANGE_QUICK_FILTER = `${NAME}/CHANGE_QUICK_FILTER`;
export const CHANGE_RA_ANALYSIS_CHECKED = `${NAME}/CHANGE_RA_ANALYSIS_CHECKED`;
export const CHANGE_CHECK_ALL = `${NAME}/CHANGE_CHECK_ALL`;
export const TOGGLE_CHECK_ALL = `${NAME}/TOGGLE_CHECK_ALL`;
export const SET_RA_ANALYSIS = `${NAME}/SET_RA_ANALYSIS`;
export const APPEND_RA_ANALYSIS = `${NAME}/APPEND_RA_ANALYSIS`;
export const SET_SORT = `${NAME}/SET_SORT`;
export const CHANGE_ALL_SHOWN_RECORDS_TO_CHECKED = `${NAME}/CHANGE_ALL_SHOWN_RECORDS_TO_CHECKED`;
export const SAVE_USER_SUBORDINATES = `${NAME}/SAVE_USER_SUBORDINATES`;
